<!--
 * @Descripttion: 大屏设计器 -- 预览
 * @Author: leo.liu
 * @Date: 2021-3-13 11:04:24
 * @Last Modified by:   leo.liu
 * @Last Modified time: 2021-3-13 11:04:24
 !-->
<template>
  <div class="layout" :style="{ 'overflow-x': 'auto', 'background-color': bgColor, }"  :class="dashboard.style === 'dark'?'workbench-dark':''">
    <a-spin size="large" :spinning="viewLoading">
      <div :style="bigScreenStyle" ref="container" style="position: relative;">
        <widget
          v-for="(widget, index) in widgets"
          :key="index"
          :index="index"
          v-model="widget.value"
          :type="widget.type"
          @timeChange="dataChange"
          :dashboard="dashboard"
          :name="name"
          :widget="widget"
          ref="widget"
          :searchCondition="searchCondition"
        />
      </div>
    </a-spin> 
  </div>
</template>

<script>
import widget from "../designer/widget/temp";
import { getAnalysisTemplatesDetails,getAnalysisTemplatesMediaDetails, getWidgetsData, getBaseWidgetsData, templateExport } from '@/api/template'
import { mapGetters } from 'vuex';
import moment from "moment"
import html2canvas from 'html2canvas'

export default {
  name: "Login",
  components: {
    widget
  },
  data() {
    return {
      bigScreenStyle: {},
      widgets: [],
      bgColor: '',
      name: '',
      dashboard: {
        style: 'normal'
      },
      filterCondition: [],
      searchCondition: []
    };
  },
  provide() {
    return {
      isbase: () => false,
      getDashboardDynamicData: () => this.dashboard?.dynamicData,
      getIndex: () => 0,
      widgetUpdate: () => {},
      filterSearch: this.filterSearch,
      setFilterCondition: this.setFilterCondition,
      getFilterCondition: () => this.filterCondition,
    };
  },
  async mounted() {
    // const reportCode = this.$route.query.reportCode;
    // console.log(reportCode)
    let canvas = {}
    let widgets = []
    const { code, data } = await getAnalysisTemplatesMediaDetails();
    if (code != 200) return;
    canvas = data.canvas
    this.dashboard.dynamicData = canvas.dynamicData
    this.dashboard.style = data.customOptions?.style || 'normal'
    widgets = data.canvas.widgets;
    this.name = data.name
    // if(reportCode) {
      
    // } else {
    //   canvas = localStorage.getItem('viewCanvas')
    //   if(canvas) {
    //     canvas = JSON.parse(canvas)
    //     widgets = canvas.widgets;
    //     this.name = canvas.name
    //   }
    // }
    let obj = widgets.find(v => v.type === 'widget-time')
    console.log(obj, '1111')

    let val,value = undefined
    if(obj&&obj.value.setup.timeSelector) {
      val = obj.value.setup.timeSelector
      value = this.$timeSelectorToDate(val)
      value = value.map(v => v.format?v.format('YYYY-MM-DD'):moment(v).format('YYYY-MM-DD'))
      obj.value.setup.value = value
    }
    widgets.forEach((v ,i) => {
      v.index = i
      if(v.dynamicDataParam&&v.type !== 'widget-table') {
        v.dynamicDataParam.pageSize = 1000
      }
      if(v.dynamicDataParam&&v.type === 'widget-table') {
        v.dynamicDataParam.pageSize = v.value.setup?.pageSize || 10
      }
      // if(canvas.dynamicData&&canvas.dynamicData.contextData?.datasource) {
      //   let context = canvas.dynamicData.contextData
      //   if(v.dynamicDataParam&&!v.dynamicDataParam.datasource) {
      //     v.dynamicDataParam.datasource = context.datasource
      //     v.dynamicDataParam.accountIds = context.accountIds
      //     v.dynamicDataParam.tableId = context.tableId
      //     v.dynamicDataParam.filterType = context.filterType
      //   }
      // }
      if(val&&v.dynamicDataParam && v.dynamicDataParam.globalDateRang) {
        v.dynamicDataParam.globalDateRang = {
          from: value[0],
          to: value[1],
          timeSelector: val
        }
      }
      // 转独立日期
      let contextData = v.value.data?.dynamicData?.contextData
      if(contextData&&contextData.dateRang&&contextData.dateRang.timeSelector) {
        let val = contextData.dateRang.timeSelector
        let value = this.$timeSelectorToDate(val)
        contextData.dateRang = {
          from: value[0],
          to: value[1],
          timeSelector: val
        }
      }
    })    
    this.widgets = widgets
    console.log(widgets)
    // text-filter
    let filters = widgets.filter(v => v.type === 'widget-text-filter')
    let filterCondition = []
    try {
      filters.forEach(v => {
        let list = v.value.data.dynamicData
        list.forEach(val => {
          val.value = v.value.data.text
          val.index = v.index
          val.name = val.dimension
          val.relation = 'AND'
        })
        filterCondition = filterCondition.concat(list)
      })
    } catch (error) {
      console.log(error)      
    }
    this.filterCondition = filterCondition
    this.bgColor =  canvas.backgroundColor;
    this.bigScreenStyle = {
      'height': canvas.height + 'px',
      'width': canvas.width + 'px',
      'background-color': canvas.backgroundColor,
      'background-image': canvas.backgroundImage?'url(' + canvas.backgroundImage + ')':'',
      'background-position': '0% 0%',
      'background-size': '100% 100%',
      'background-repeat': 'initial',
      'background-attachment': 'initial',
      'background-origin': 'initial',
      'background-clip': 'initial',
      'margin-left': 'auto',
      'margin-right': 'auto'
    }
    if(!obj) {
      this.getData()
    }
  },
  computed: {
    ...mapGetters({
        viewLoading: 'viewLoading'
    }),
  },
  methods: {
    setFilterCondition(index, value) {
      this.filterCondition.filter(v => v.index === index).forEach(v => {
        v.value = value
      })
    },
    filterSearch() {
      let widgets = this.$deepclone(this.widgets)
      widgets.forEach((v, i) => {
        if(v.type === 'widget-table'&&v.dynamicDataParam) {
          let wRef = this.$refs.widget[i]?.$refs?.component
          v.dynamicDataParam.orders = wRef?.orders?.length?wRef.orders:v.dynamicDataParam.orders
          v.dynamicDataParam.conditions
 = v.dynamicDataParam?.conditions?.concat(wRef?.filterConditions || [])
        }
      })
      this.getData(widgets)
      try {
        let hasDateRangList = widgets.filter((v, i) => v.dynamicDataParam&&v.dynamicDataParam.dateRang&&v.dynamicDataParam.dateRang.from)
        if(hasDateRangList.length) {
          hasDateRangList.forEach(v => {
            this.$refs.widget[v.index].filterSearch()
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    //  导出
    async exportDashboard() {
      if (!this.name) {
        this.$message.error("名称不能为空");
        return;
      }
      let canvasID = this.$refs['container']
      this.$store.commit("modelDesign/SET_VIEW_LOADING", true);
      html2canvas(canvasID).then(async (canvas) => {
        let dom = document.body.appendChild(canvas)
        dom.style.display = 'none'
        document.body.removeChild(dom)
        let blob = this.dataURLToBlob(dom.toDataURL('image/png'))
        URL.revokeObjectURL(blob)
        let widgets = JSON.parse(JSON.stringify(this.widgets));
        console.log(widgets)
        widgets = widgets.filter(v => v.value?.data?.dataType === "dynamicData").map(v => ({ 
          dynamicDataParam: { 
            ...v.value.data?.dynamicData || {},
            ...v.value.data?.dynamicData?.contextData?v.value.data.dynamicData.contextData:{}
          },
          type: v.type
        }))
        console.log(widgets)
        let param = new FormData()       // 创建form对象     
        param.append('file', blob)       // 通过append向form对象添加数据
        param.append("template", JSON.stringify({
          name: this.name,
          widgets
        })); // 添加form表单中其他数据
        const res = await templateExport(param)
        if(res.code === 200) {
          this.$message.success('数据导出中，请稍后在【下载中心】查看')
        }
        console.log(res)
        this.$store.commit("modelDesign/SET_VIEW_LOADING", false);
      })
    },
    dataURLToBlob(dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while(n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr, {type: mime}])
    },
    dataChange(val) {
      console.log(val)
      this.widgets.forEach(v => {
        if(v.dynamicDataParam && v.dynamicDataParam.globalDateRang) {
          v.dynamicDataParam.globalDateRang = val
        }
        if(v.value.data?.dynamicData?.contextData) {
          v.value.data.dynamicData.contextData.globalDateRang = val
        }
      })
      this.getData()
    },
    async getData() {
      console.log(this.widgets)
      let params = this.widgets.map((v, i) => ({
        index: i,
        ...v,
        options: undefined,
        value: undefined
      })).filter(v => v.dynamicDataParam)
      if(params.length) {
        this.$store.commit("modelDesign/SET_VIEW_LOADING", true);
        let query = this.$route.query
        let api = query.isbase?getBaseWidgetsData:getWidgetsData
        api(params).then((res) => {
          console.log(res)
          let data = res.data || {}
          Object.keys(data).forEach(key => {
            this.$nextTick(() => {
              this.$refs.widget[key].init(data[key])
            })
          })
        }).finally(() => this.$store.commit("modelDesign/SET_VIEW_LOADING", false))
      }
    }
  }
};
</script>

<style scoped lang="less">
.layout {
  width: 100%;
  height: 100%;
  text-align: center;
}
.bottom-text {
  width: 100%;
  color: #a0a0a0;
  position: fixed;
  bottom: 16px;
  z-index: 9999;
}
/deep/ .ant-spin-nested-loading > div > .ant-spin{
  max-height: none;
}

.export-btn {
  text-align: right;
  margin-right: 24px;
  margin-top: 12px;
  margin-bottom: 12px;
}
</style>
